import AppSettings from './AppSettings';

class Endpoints {
	constructor() {
		this.FileCompression = `${AppSettings.HOST}/image/compress`;
		this.Download = `${AppSettings.HOST}/image/download`;
		this.Upload = `${AppSettings.HOST}/image/upload`;
		this.Delete = `${AppSettings.HOST}/images`;
		this.Recompress = `${AppSettings.HOST}/image/recompress`;
		this.CompressToSize = `${AppSettings.HOST}/image/compress-to-size`;
	}
}

const instance = new Endpoints();
Object.freeze(instance);
export default instance;



// WEBPACK FOOTER //
// ./src/EndPoints.js